import React, { useContext, memo } from "react";
import { Polygon } from "@react-google-maps/api";
import { WebMapContext } from "../WebMapGoogleMap";
import { convertGeohashToPolygon } from "../../../../utils/helper";

const CapacityGeohashSection = ({
  eyeIcons,
  capacityGeohashes,
  selectedCapacityGeohashes,
  mapTool,
  onClickCapacityGeohash,
  geohashZoom,
  filterType = null,
  dataColors,
}) => {
  const { mapZoomLevel } = useContext(WebMapContext);
  const loadGeohashes = (displayGeohashes = []) => {
    return mapZoomLevel >= geohashZoom && eyeIcons.capacity && displayGeohashes.length > 0 ? (
      <div className="data-on-map">
        {displayGeohashes?.map((data, index) => {
          let geohashColor;
          const valueMap = {};
  
          dataColors.length && dataColors?.[0].values.forEach((value) => {
            valueMap[value.text] = value.markerColor;
          });
          geohashColor =
            filterType === "action"
              ? valueMap[data.action]
              : filterType === "flag"
              ? valueMap[data.flag]
              : "";
          return (
            <Polygon
              path={convertGeohashToPolygon(data.geohash)}
              key={index}
              options={{
                fillColor: geohashColor,
                fillOpacity: geohashColor ? 0.8 : 0,
                strokeColor: "#bdbdbd",
                strokeOpacity: geohashColor ? 0.8 : 0,
                strokeWeight: 0.8,
                clickable: mapTool ? false : true,
                draggable: false,
                editable: false,
                geodesic: false,
                zIndex: 1,
              }}
              scale={2}
              onClick={() => {
                onClickCapacityGeohash(data);
              }}
            />
          );
        })}
      </div>
    ) : (
      <></>
    );
  }

  return(
    <>
    {loadGeohashes(capacityGeohashes)}
    {loadGeohashes(selectedCapacityGeohashes)}
    </>
  )
};
export default memo(CapacityGeohashSection);
